import * as moment from 'moment';

import { TimeUnit, DayOfWeek } from '../../../models';
import { IAlignmentStrategy } from './IAlignmentStrategy';

export class WeekAlignmentStrategy implements IAlignmentStrategy {
    align(
        input: moment.Moment,
        beginTime: moment.Duration,
        interval: number,
        intervalTimeUnit: TimeUnit,
        dayOfWeek: DayOfWeek
    ): moment.Moment {
        let result: moment.Moment = null;
        
        if (intervalTimeUnit === TimeUnit.Week) {
            // isoWeek always start on monday, not using locale
            const dayDelta = dayOfWeek - DayOfWeek.Monday;
            result = moment(input.toISOString()).startOf('isoWeek');

            result            
                .add(moment.duration(dayDelta, 'd').asDays(), 'd')
                .add(beginTime.asMinutes(), 'm')
                .milliseconds(0);

            while (result.isBefore(input)) {
                result = result.add(interval, 'w');
            }
        }

        return result;
    }
}